module.exports = __webpack_public_path__ + "static/warehouse-exp-img-1-86fcfd28ac721ff43da77d8718769ee9.png";